<template>
    <modal id="create-field-inspection">
        <template slot="title">Create Field Inspection</template>
        <template slot="body">
            <field-inspection-form :form="form" @on-project="updateEmployer($event)"></field-inspection-form>
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-default" @click="closeModal('create-field-inspection')">Cancel</button>
            <button type="button" class="btn btn-success" :disabled="form.isSubmitted" @click="save()">Save</button>
        </template>
    </modal>
</template>
<script>
    export default {

        data() {
            return {
                form: new Form({
                    type: '',
                    trigger: '',
                    employer_id: null,
                    technician_id: '',
                    inspector_id: '',
                    status: null,
                    notified_at: moment().format('Y-MM-DD H:mm:ss'),
                    paid_at: null,
                    review_at: null,
                    scheduled_at: null,
                    project_id: null,
                    inspector_project_id: null,
                    project_number: null,
                    query: '',
                    clearForm: false
                }).dontClear()
            }
        },

        methods: {

            save() {
                this.form.post('/field-inspections').then(response => {
                    this.closeModal('create-field-inspection');
                    Alert.withAction('Field Inspection Created').then(() => {
                         this.redirectTo(`/field-inspections/${response.number}`);
                    });
                }).catch(errors => {
                    Alert.error(errors.first());
                })
            },

            updateEmployer(project) {
                this.form.employer_id = project.employer.id
            }
        },
    }
</script>
